import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isShow: true
  },
  getters: {
  },
  mutations: {
    SET_ISSHOW: (state, falg) => {
      state.isShow = falg
    }
  },
  actions: {
  },
  modules: {
  }
})
